import { Component, OnInit } from '@angular/core';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { Subscription } from 'rxjs';
import { BuildingManagementService } from 'src/app/building-managment/building-management.service';
import { ERROR_CODES } from 'src/app/shared/constants/error-codes';
import ExtendableError from 'es6-error';
import { ServiceUnavailableError } from 'src/app/shared/errors/errors';
import { Utility } from 'src/app/shared/utils/utility.service';
import { CommonService } from 'src/app/shared/utils/common.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
@Component({
  selector: 'app-site-details',
  templateUrl: './site-details.component.html',
  styleUrls: ['./site-details.component.scss'],
})
export class SiteDetailsComponent implements OnInit {
  sharedData: any;
  subscription: Subscription | undefined;
  buildingsList: any;
  selectedSiteId: any | undefined;
  constructor(
    public sharedDataService: SharedDataService,
    public buildingManagementService: BuildingManagementService,
    public commonService: CommonService,
    private stateManagementService: StateManagementService
  ) {}

  ngOnInit(): void {
    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => {
        //getting previous siteId
        this.sharedData = sharedData;
        // if previous site id is equal to current site id, don't call API
        if (
          Utility.checkValidValue(this.sharedData?.selectedSite?.siteId) &&
          (!this.selectedSiteId ||
            (Utility.checkValidValue(this.selectedSiteId) &&
              this.selectedSiteId !== this.sharedData.selectedSite.siteId))
        ) {
          const showLoaderIfStoreEmpty =
            this.stateManagementService.getBuildings() ? true : false;

          this.buildingManagementService
            .getAllBuildingsBySiteId(
              this.sharedData?.selectedSite?.siteId,
              showLoaderIfStoreEmpty
            )
            .subscribe({
              next: (res: any) => {
                if (res?.length > 0) {
                  this.buildingsList = [...res];

                  this.buildingsList?.forEach((currentBuilding: any) => {
                    if (
                      this.sharedData.selectedBuilding.buildingId ===
                      currentBuilding?.buildingId
                    ) {
                      currentBuilding.buildingName;
                      currentBuilding.buildingAddress;
                      currentBuilding.buildingImg;
                      currentBuilding.buildingImgName;

                      this.sharedDataService.updateSelectedBuilding({
                        buildingId: currentBuilding?.buildingId,
                        buildingName: currentBuilding.buildingName,
                      });
                    }
                  });
                }
                if (this.sharedData?.selectedSite?.siteId !== '')
                  this.buildingManagementService.buildingsView = true;
                this.buildingManagementService.isEmpty = false;
              },
              error: (
                err: Error | ExtendableError | ServiceUnavailableError
              ) => {
                if (
                  err instanceof ServiceUnavailableError &&
                  err?.type === ERROR_CODES.INTERNAL_SERVER_ERROR
                ) {
                  this.buildingManagementService.buildingsView = true;
                  this.buildingManagementService.isEmpty = true;
                } else {
                  this.buildingManagementService.buildingsView = false;
                  this.buildingManagementService.isEmpty = false;
                }
              },
            });
        }
        this.selectedSiteId = this.sharedData.selectedSite.siteId;
      }
    );
  }
}
